import SpriteSymbol from "../../../.yarn/cache/svg-baker-runtime-npm-1.4.3-83b301e572-cae068de31.zip/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../.yarn/cache/svg-sprite-loader-npm-4.2.1-14e35b6f3a-33d9521566.zip/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_general_archive_solid",
  "use": "icon-icon_general_archive_solid-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-icon_general_archive_solid\">\n<g>\n\t<g>\n\t\t<polygon class=\"st0\" points=\"41,11 7,11 7,17 7,17 41,17 \t\t\" />\n\t</g>\n\t<path class=\"st0\" d=\"M10,20v19h28V20H10z M28,26h-8v-3h8V26z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol